import React from "react";
import Card from "../Materials/Card.js";
import Footer from "./Footer.js";
import NavBar from "./NavBar.js";
import classes from "../../styles/Layout.module.css";

const Layout = (props) => {
  return (
    <div className={classes.container}>
      <NavBar />
      <div className={classes.container}>{props.children}</div>
      <Footer />
    </div>
  );
};

export default Layout;
